/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-08-24T17:05:26.909
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	saveRentHouseLockLog,
	getRentHouseLockLogCreateInit,
	getRentHouseLockLogEditInit,
	getRentHouseLockLogView,
	deleteRentHouseLockLog
} from '@api/rentmanage/RentHouseLockLog';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},
	actions: {
		getRentHouseLockLogCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getRentHouseLockLogCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentHouseLockLogEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentHouseLockLogEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveRentHouseLockLog({}, RentHouseLockLog) {
			return new Promise((resolve, reject) => {
				saveRentHouseLockLog(RentHouseLockLog)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		getRentHouseLockLogView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentHouseLockLogView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		deleteRentHouseLockLog({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentHouseLockLog({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
